import irelandApi from '../irelandApi';
import {
  GET_USER_PRODUCTS_LIST_PENDING,
  GET_USER_PRODUCTS_LIST_FULFILLED,
  GET_USER_PRODUCTS_LIST_REJECTED
} from '../reducers/userProductsListReducer';

// eslint-disable-next-line import/prefer-default-export
export const getProducts = () => (dispatch) => {
  dispatch({ type: GET_USER_PRODUCTS_LIST_PENDING });

  return irelandApi.get('/api/products/list')
    .then(({ data: { data: products }}) =>
      dispatch({ type: GET_USER_PRODUCTS_LIST_FULFILLED, payload: products }))
    .catch((error) => {
      if (error.response) {
        const { data } = error.response;
        dispatch({ type: GET_USER_PRODUCTS_LIST_REJECTED, payload: data });
      }
    });
};
